import {
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import { useContext, useEffect, useState } from "react";
import { startTransition } from "react";
import type { getDifferencesBetweenConfigsReturn } from "./helper";
import { getDifferencesBetweenConfigs } from "./helper";
import { SaveModalPickItemToRender } from "./PickItemToRender";
import styled from "styled-components";
import { configItemContext } from "../../inputList";
import {
  useInventoryConfigCreate,
  useInventoryConfigUpdate
} from "@dealer-center/ddc-pages-inventory-config-fetch";
import type { InventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import { SaveAndCancel } from "@dealer-center/core-custom-components";

const StyledDifference = styled.ul`
  margin-bottom: 4px;
`;

export const SaveModal = () => {
  const { selectedConfig, curentConfig, isNewConfig, resetConfig } =
    useContext(configItemContext);

  const updateMutation = useInventoryConfigUpdate();
  const createMutation = useInventoryConfigCreate();

  const [showSaveModal, setShowSaveModal] = useState(false);
  const [changes, setChanges] = useState<getDifferencesBetweenConfigsReturn[]>(
    []
  );
  const { toastError } = useToaster();
  const shouldSaveBeDisabled = changes.length === 0 && !isNewConfig;
  useEffect(() => {
    startTransition(() => {
      const changes: getDifferencesBetweenConfigsReturn[] =
        getDifferencesBetweenConfigs(selectedConfig, curentConfig);
      setChanges(changes);
    });
  }, [selectedConfig, curentConfig, isNewConfig]);
  useEffect(() => {
    if (createMutation.isError) {
      toastError("Error creating config");
    }
  }, [createMutation.isError]);
  useEffect(() => {
    if (updateMutation.isError) {
      toastError("Error updating config");
    }
  }, [updateMutation.isError]);

  return (
    <>
      <SaveAndCancel
        analyticsEventName={"website inventory config"}
        cancelButtonText="Reset"
        isDisabled={{
          save: shouldSaveBeDisabled,
          cancel: !selectedConfig
        }}
        onCancel={() => {
          if (!selectedConfig) return;
          resetConfig();
        }}
        onSave={() => setShowSaveModal(true)}
      />
      <Modal
        footer={{
          primary: {
            label: "unused"
          },
          footerComponent: (
            <ModalFooter>
              <SaveAndCancel
                analyticsEventName={"website inventory config save modal"}
                isSaving={updateMutation.isPending || createMutation.isPending}
                onCancel={() => setShowSaveModal(false)}
                onSave={async () => {
                  const changesToSend: Partial<InventoryListingConfig> = {};
                  changes.forEach(change => {
                    (changesToSend[change.config] as unknown) = change.newValue;
                  });
                  if (isNewConfig) {
                    createMutation.mutate(curentConfig);
                  } else {
                    updateMutation.mutate(curentConfig);
                  }
                }}
              />
            </ModalFooter>
          )
        }}
        header="Save Resources Changes"
        show={showSaveModal}
        size="small"
        onHide={() => setShowSaveModal(false)}
      >
        <ModalContent>
          {changes.map(change => (
            <StyledDifference key={change.config}>
              <SaveModalPickItemToRender change={change} />
            </StyledDifference>
          ))}
        </ModalContent>
      </Modal>
    </>
  );
};
